import { Directive, Host, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';
import { InputComponent } from '../../components/input/input.component';
import { FormErrorConnectorDirective } from '../form-error-connector.directive';
import { BaseFormConnectorDirective } from './base-form-connector.directive';

@Directive({
  selector: '[dsdExtInputExtConnector], dsd-ext-input',
  providers: [
    {
      provide: FormErrorConnectorDirective,
      useExisting: InputExtConnectorDirective
    }
  ],
  standalone: false
})
export class InputExtConnectorDirective extends BaseFormConnectorDirective {
  get hasError() {
    return super.hasError;
  }
  set hasError(value) {
    super.hasError = value;
    /**
     * Pour le dsd-ext-input, on doit par le component, sinon
     * Angular ne détecte pas le changement de l'attribut error
     * dans le DOM
     */
    this.component.error = value;
  }

  constructor(@Host() private readonly component: InputComponent, @Host() @Optional() control: NgControl) {
    super(control);
  }
}
